<template>
  <div class="c_table_wrap">
    검출 의뢰 내역 리스트 레이아웃
    <div>
      <button @click="$router.back()" class="mr30">목록</button>
      <button @click="$router.back()" class="mr30">보상금 입력</button>
      <button @click="$router.back()" class="mr30">상태변경</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "HistoryListDetectionRequestLayout",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>